import { ReplicaType } from "types";
import Version1 from "./version-1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-letter-harry-potter-03-railview-hotel",
  name: `Harry Potter Acceptance Letter\n'Railview Hotel'`,
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
